import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { Jobs } from 'app/shared/models/jobs.model';
import { ApiService } from 'app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-project-edit',
  templateUrl: './project-edit.component.html',
  styleUrls: ['./project-edit.component.scss']
})
export class ProjectEditComponent implements OnInit {
  jobsForm:FormGroup
  job_id:any;
  selectedValue:'';
  categories=[]
  jobModel={
    Communication: '',
    sprints: '',
    mom: '',
    dmsfrs: '',
    kpi: '',
    reports: '',
    workdairy: '',
    bitbucket: '',
    demo:'' ,
    qa: '',
    crequest:'' ,
    isalert:''
  }
  job_data:any

  alert_list = [
    { id: 'yes', name: 'Yes' },
    { id: 'no', name: 'No' },
  ]
  alert_event = 'no'

  constructor(private activatedroute:ActivatedRoute,
    public toastr: ToastrService,
    private route:Router,public apiService:ApiService)
   {
    this.activatedroute.paramMap.subscribe(params => { 
      this.job_id = params.get('id'); 
  });
    }

  ngOnInit(): void {
    this. getJobsById()
  }
  getJobsById() {
    this.apiService.getJobsById(this.job_id).subscribe((res: any) => {
      if(res.statusCode === 200){
        for(let item of res?.data){
          this.job_data=item
        }
        this.jobModel.Communication = this.job_data?.Communication?.name
        this.jobModel.sprints = this.job_data?.sprints?.name
        this.jobModel.mom = this.job_data?.mom?.name
        this.jobModel.dmsfrs = this.job_data?.dmsfrs?.name
        this.jobModel.kpi = this.job_data?.kpi?.name
        this.jobModel.reports = this.job_data?.reports?.name
        this.jobModel.workdairy = this.job_data?.workdairy?.name
        this.jobModel.bitbucket = this.job_data?.bitbucket?.name
        this.jobModel.demo = this.job_data?.demo?.name
        this.jobModel.qa = this.job_data?.qa?.name
        this.jobModel.crequest = this.job_data?.crequest?.name
        this.jobModel.isalert = this.job_data?.isalert
        this.alert_event=this.jobModel.isalert
      }
    })

  }
  selectAlert(event) {
    this.alert_event
    this.jobModel.isalert = this.alert_event
  }
  updateJob(){
    // let obj={
    //   alert:'no',
    //   last_audit:'',
    //   name:this.jobModel.Communication
    // },
    // obj2 ={
    //   alert:'no',
    //   last_audit:'',
    //   name:this.jobModel.sprints
    // },
    //  obj3={
    //   alert:'no',
    //   last_audit:'',
    //   name:this.jobModel.mom
    // },
    //  obj4={
    //   alert:'no',
    //   last_audit:'',
    //   name:this.jobModel.dmsfrs
    // },
    //  obj5={
    //   alert:'no',
    //   last_audit:'',
    //   name:this.jobModel.kpi
    // },
    //  obj6={
    //   alert:'no',
    //   last_audit:'',
    //   name:this.jobModel.reports
    // },
    //  obj7={
    //   alert:'no',
    //   last_audit:'',
    //   name:this.jobModel.workdairy
    // },
    //  obj8={
    //   alert:'no',
    //   last_audit:'',
    //   name:this.jobModel.bitbucket
    // },
    //  obj9={
    //   alert:'no',
    //   last_audit:'',
    //   name:this.jobModel.demo
    // },
    //  obj10={
    //   alert:'no',
    //   last_audit:'',
    //   name:this.jobModel.qa
    // },
    //  obj11={
    //   alert:'no',
    //   last_audit:'',
    //   name:this.jobModel.crequest
    // }
    let body={
      Communication: {
        name:this.jobModel.Communication,
        alert : 'no',
        lastaudit : ''
      },
      sprints: {
        name:this.jobModel.sprints,
        alert : 'no',
        lastaudit : ''
      },
      mom: {
        name:this.jobModel.mom,
        alert : 'no',
        lastaudit : ''
      },
      dmsfrs: {
        name:this.jobModel.dmsfrs,
        alert : 'no',
        lastaudit : ''
      },
      kpi: {
        name:this.jobModel.kpi,
        alert : 'no',
        lastaudit : ''
      },
      reports: {
        name:this.jobModel.reports,
        alert : 'no',
        lastaudit : ''
      },
      workdairy: {
        name:this.jobModel.workdairy,
        alert : 'no',
        lastaudit : ''
      },
      bitbucket: {
        name:this.jobModel.bitbucket,
        alert : 'no',
        lastaudit : ''
      },
      demo: {
        name:this.jobModel.demo,
        alert : 'no',
        lastaudit : ''
      },
      qa: {
        name:this.jobModel.qa,
        alert : 'no',
        lastaudit : ''
      },
      crequest: {
        name:this.jobModel.crequest,
        alert : 'no',
        lastaudit : ''
      },
      isalert: this.jobModel.isalert
    }
    console.log(body)
    this.apiService.updateJob(this.job_id,body).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.toastr.success(res.message)
      this.route.navigate(['/project/project-list'])
      }
      else{this.toastr.error(res.error)} 
    })
 }
  back(){
    this.route.navigate(['/project/project-list'])
  }
}